module.exports = __webpack_public_path__ + "124d5b4cbaaa19f7.css";